import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import {
  dateSchema,
  parseToDateValue,
  preprocessTextAsyncAutocompleteField,
} from "@/features/FormCard/utils";
import { z } from "zod";

// Zod schema for the filter form
export const filterTptStaticDataSchema = z.object({
  time_serie_file_date_filename_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional(),
  strategy_name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterTptStaticDataSchema = z.infer<
  typeof filterTptStaticDataSchema
>;

export const fields: Field[] = [
  {
    name: "time_serie_file_date_filename_contains",
    label: "Time Series File Date",
    type: "asyncAutocomplete",
    base_url: "instit-quantilia/time_serie_file_dates",
    column_name: "filename",
  },
  {
    name: "strategy_name_contains",
    label: "Strategy",
    type: "asyncAutocomplete",
    base_url: "etl-quantilia/strategies",
    column_name: "name",
  },
  {
    name: "created_at_from",
    label: "Created From",
    type: "date",
  },
  {
    name: "created_at_to",
    label: "Created To",
    type: "date",
  },
];

export const client = "qtl - referential";

export function FilterTptStaticData() {
  return (
    <FilterTable
      client={client}
      schema={filterTptStaticDataSchema}
      tableName="tpt_static_data"
      customBuildPath={() => `${client}/tpt_static_data`}
      fields={fields}
    />
  );
}
